<template>
    <div
        v-html="
            $t(
                `patients.preventionAndLongevity.packages.details.item${id}.title`,
            )
        "
    ></div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, h } from "vue";

const route = useRoute();
const router = useRouter();

// Access the 'id' route parameter
const id = ref(route.params.id);
const item = ref(null);

function goBack() {
    router.back();
}

// Simple gear icon component (inline SVG)
const GearIcon = (props: { class?: string }) =>
    h(
        "svg",
        {
            ...props,
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg",
        },
        [
            h("path", {
                d: "M13.94 2.06a1.5 1.5 0 012.12 0l1.88 1.88a1.5 1.5 0 010 2.12l-1.31 1.31a7.007 7.007 0 010 4.26l1.31 1.31a1.5 1.5 0 010 2.12l-1.88 1.88a1.5 1.5 0 01-2.12 0l-1.31-1.31a7.007 7.007 0 01-4.26 0l-1.31 1.31a1.5 1.5 0 01-2.12 0l-1.88-1.88a1.5 1.5 0 010-2.12l1.31-1.31a7.007 7.007 0 010-4.26L2.06 6.06a1.5 1.5 0 010-2.12l1.88-1.88a1.5 1.5 0 012.12 0l1.31 1.31a7.007 7.007 0 014.26 0l1.31-1.31zM10 13a3 3 0 100-6 3 3 0 000 6z",
            }),
        ],
    );
</script>
<style scoped>
@keyframes spin-slow {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.animate-spin-slow {
    animation: spin-slow 8s linear infinite;
}
</style>
